import { render, staticRenderFns } from "./AddOpportunity.vue?vue&type=template&id=701742c1&"
import script from "./AddOpportunity.vue?vue&type=script&lang=js&"
export * from "./AddOpportunity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports